const track_checkout = !0,
    persistentParams = ["ttclid", "utm_campaign", "utm_medium", "utm_source", "sdp", "domain"],
    forcePixelRules = [{ from: "x.com", to: "y.com" }];
(function () {
    const urlParams = new URLSearchParams(window.location.search);
    persistentParams.forEach((param) => {
        let value = urlParams.get(param);
        value && (document.cookie = `${param}=${value}; path=/; max-age=2592000`);
    });
})();
function getCookieValue(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
}
function injectPersistentParamsInUrl() {
    const url = new URL(window.location.href);
    let modified = !1;
    persistentParams.forEach((param) => {
        if (!url.searchParams.has(param)) {
            let value = getCookieValue(param);
            value && (url.searchParams.set(param, value), (modified = !0));
        }
    }),
        modified && window.history.replaceState(null, "", url.toString());
}
["pushState", "replaceState"].forEach((method) => {
    const original = history[method];
    history[method] = function (...args) {
        original.apply(this, args), window.dispatchEvent(new Event("urlchange"));
    };
}),
    window.addEventListener("popstate", () => {
        window.dispatchEvent(new Event("urlchange"));
    }),
    window.addEventListener("urlchange", injectPersistentParamsInUrl),
    injectPersistentParamsInUrl();
const iframePixel = document.createElement("div");
(iframePixel.id = "iframePixel"), (iframePixel.style.display = "none"), document.body.insertBefore(iframePixel, document.body.firstChild);
function generateSecretKey() {
    const secretArray = { 0: "Q", 1: "M", 2: "Z", 3: "L", 4: "T", 5: "X", 6: "N", 7: "V", 8: "R", 9: "K" },
        getRandomLetters = (length) => {
            const letters = "QMZLTXNVRK";
            let result = "";
            for (let i = 0; i < length; i++) result += letters[Math.floor(Math.random() * letters.length)];
            return result;
        },
        timestampStr = String(Math.floor(Date.now() / 1e3));
    let secret = "";
    for (let i = 0; i < timestampStr.length; i++) {
        const char = timestampStr[i];
        secret += secretArray[char] || "?";
    }
    const prefix = getRandomLetters(10),
        suffix = getRandomLetters(10);
    return `${prefix}-${secret}-${suffix}`;
}
function getPersistentParamsForIframe() {
    const urlParams = new URLSearchParams(window.location.search),
        collected = {};
    return (
        persistentParams.forEach((param) => {
            const value = urlParams.get(param);
            value && (collected[param] = value);
        }),
        collected
    );
}
function buildTrackingIframeSrc(baseUrl, additionalParams = {}) {
    const allParams = { ...getPersistentParamsForIframe(), ...additionalParams, s: generateSecretKey() },
        query = new URLSearchParams(allParams).toString();
    return `${baseUrl}?${query}`;
}
function getDuplicatedDomains(baseDomain2) {
    const domains = [baseDomain2];
    return (
        forcePixelRules.forEach((rule) => {
            rule.from === baseDomain2 && domains.push(rule.to);
        }),
        domains
    );
}
const subdomainPixel = getCookieValue("sdp"),
    baseDomain = getCookieValue("domain"),
    custom_domain_pixel = subdomainPixel ? subdomainPixel + "." + baseDomain : null;
if (subdomainPixel && baseDomain) {
    const domainsToTrack = getDuplicatedDomains(baseDomain);
    domainsToTrack.forEach((domain) => {
        const fullDomain = `${subdomainPixel}.${domain}`,
            iframePageView = document.createElement("iframe");
        (iframePageView.src = buildTrackingIframeSrc(`https://${fullDomain}/`, { action: "PageView" })),
            (iframePageView.style.width = "1px"),
            (iframePageView.style.height = "1px"),
            (iframePageView.style.border = "0"),
            (iframePageView.referrerPolicy = "no-referrer"),
            (iframePageView.id = `iframePixelPageView-${domain.replace(/\./g, "-")}`),
            document.getElementById("iframePixel").appendChild(iframePageView);
    }),
        (window.QPActionATC = function (variantId, productName, productHandle, productPrice, shopCurrency) {
            domainsToTrack.forEach((domain) => {
                const fullDomain = `${subdomainPixel}.${domain}`,
                    iframeAddToCart = document.createElement("iframe");
                (iframeAddToCart.src = buildTrackingIframeSrc(`https://${fullDomain}/`, { action: "AddToCart", price: productPrice, currency: shopCurrency, variant_id: variantId })),
                    (iframeAddToCart.style.width = "1px"),
                    (iframeAddToCart.style.height = "1px"),
                    (iframeAddToCart.style.border = "0"),
                    (iframeAddToCart.referrerPolicy = "no-referrer"),
                    (iframeAddToCart.id = `iframePixelAddToCart-${domain.replace(/\./g, "-")}`),
                    document.getElementById("iframePixel").appendChild(iframeAddToCart);
            });
        });
}